export enum RoutesEnum {
  AUTH_REDIRECT = 'auth-redirect',
  ERROR = 'error',
  SIGN_IN = 'sign-in',
  DASHBOARD = 'dashboard',
  REDIRECT_LOGIN = 'redirect-login',
  USER_SUSPENDED = 'user-suspended',
  SIGN_OUT = 'sign-out',
  INVOICES = 'invoices',
  SETTINGS = 'settings',
  DEMO = 'demo',
  DELEGATIONS = 'delegations',
  USER = 'user',
  NEWS = 'news',
  CHANGELOG = 'changelog',
}
